import type { ReactElement } from 'react';

import { LinguiClientProvider } from '@/lib/i18n';

enum LANGUAGES {
  DEFAULT = 'en'
}

const i18nContent = {
  en: {}
};

const LinguiTestingProvider = ({
  children,
  locale = LANGUAGES.DEFAULT
}: {
  children: ReactElement;
  locale?: LANGUAGES.DEFAULT;
}) => {
  const i18n = i18nContent[locale]!;

  return (
    <LinguiClientProvider initialLocale={locale} initialMessages={i18n}>
      {children}
    </LinguiClientProvider>
  );
};

export { LinguiTestingProvider };
